
export function isNullOrUndefined<T>(value: T | null | undefined): value is null | undefined {
  // eslint-disable-next-line no-undefined
  return value === null || value === undefined;
}

export function isNotNullOrUndefined<T>(value: T | null | undefined): value is T {
  return !isNullOrUndefined(value);
}
